import qs from 'qs'
const obj = {}
obj.install = function(Vue,options){
  Vue.prototype.$Qs = qs
}

export default obj



// WEBPACK FOOTER //
// ./src/utils/qsPlugin.js